import { useState } from "react";
import Layout from "components/layout";
import Hero from "./hero";
import HomeSlider from "./homeSlider";
import TopCity from "./topCity";
import Download from "./download";
import RecentBooking from "./recentBooking";
import RecentSearch from "./recentSearch";
import { Explore, SearchBuses, Hot } from "sections";
import { useGetHomeDataQuery } from "../../redux/services/homeServices";

export default function Home() {
  const [loading, setLoading] = useState(false);
  const { isLoading, data } = useGetHomeDataQuery();

  return (
    <Layout>
      <div className="w-full flex flex-col items-center">
        <Hero isLoading={isLoading} data={data?.banner || []} />
        <div className="w-full max-w-8xl margins flex flex-col">
          <SearchBuses
            isHome={true}
            loading={loading}
            setLoading={setLoading}
          />
          <HomeSlider />
          {!isLoading && data?.tickethistory?.length ? (
            <RecentBooking
              isLoading={isLoading}
              data={data?.tickethistory || []}
            />
          ) : null}

          <RecentSearch />
          <Hot />
          <Explore className="mb-[40px] md:mb-[60px]" />
          <TopCity />
        </div>
        <div className="w-full hidden md:block">
          <Download />
        </div>
      </div>
    </Layout>
  );
}
